import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Accessory, ConfigAccessory } from "src/app/clearpath-module/models";

@Component({
  selector: "app-featured-accessories",
  templateUrl: "./featured-accessories.component.html",
  styleUrls: ["./featured-accessories.component.scss"]
})
export class FeaturedAccessoriesComponent {
  @Input() accessories: ConfigAccessory[];
  @Output() changes = new EventEmitter<ConfigAccessory[]>();

  constructor() { }

  onChanges({accessory, index}) {
    if (accessory) {
      this.accessories[ index ] = accessory;
    } else {
      this.accessories.splice(index, 1);
    }
    this.changes.emit(this.accessories);
  }

  createItem() {
    const newAccessory: ConfigAccessory = {
      accessoryLink: {
        iconUrl: "",
        linkUrl: "",
        description: ""
      },
      hidden: false,
      disabled: false,
      name: "New Accessory (Click To Edit)",
      tagLine: "",
      details: [],
      preLoad: true,
      pbsName: "",
      pbsType: "",
      options: [{
        name: "Default Option",
        label: "Default Option",
        pbsName: "",
        price: 0,
        cost: 0,
        details: [],
        defaultSelection: false
      }],
    };
    this.accessories.unshift(newAccessory);
    this.changes.emit(this.accessories);
  }
}
